import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { API_URL } from "../config";

const WatermarkBanner = ({ location }) => {
  const isStateEnvironment = API_URL.includes("stage");
  const [shouldBeRender, setShouldBeRender] = useState(isStateEnvironment);
  if (!isStateEnvironment) return <></>;

  return <PageWatermark location={location} shouldBeRender={shouldBeRender} setShouldBeRender={setShouldBeRender} />;
};

const PageWatermark = ({ location, shouldBeRender, setShouldBeRender }) => {
  const [spansList, setSpansList] = useState([]);
  const waterMarkRef = useRef(null);
  const text = "app.demonstration.site";

  const watermarkStyle = {
    backgroundColor: "red",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    padding: "0 20px",
    color: "white",
    overflow: "hidden",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 24,
    whiteSpace: "nowrap",
    userSelect: "none",
    zIndex: 1999,
    height: 16,
  };

  const handleClick = () => {
    setShouldBeRender(false);
  };

  const calculateWindowSize = useCallback(() => {
    if (!waterMarkRef.current) return;
    const gap = 24;
    const textSize = waterMarkRef.current.offsetWidth + gap;
    const viewSize = window.innerWidth;
    const total = Math.ceil(viewSize / textSize) + 1;

    const elements = Array(total)
      .fill(text)
      .map((element, index) => (
        <span key={index}>
          <FormattedMessage id={element} />
        </span>
      ));
    setSpansList(elements);
  }, []);

  useLayoutEffect(() => {
    calculateWindowSize();
    window.addEventListener("resize", calculateWindowSize);
    return () => window.removeEventListener("resize", calculateWindowSize);
  }, [calculateWindowSize]);

  useEffect(() => {
    setShouldBeRender(true);
  }, [location, calculateWindowSize, setShouldBeRender]);

  if (!shouldBeRender) {
    return <></>;
  }

  return (
    <div style={watermarkStyle} onClick={handleClick}>
      <span ref={waterMarkRef} style={{ position: "absolute", visibility: "hidden", whiteSpace: "nowrap" }}>
        {/* necessário para para calcuular o tamanho de um span fixo, por isto fica oculto*/}
        <FormattedMessage id={text} />
      </span>
      {spansList}
    </div>
  );
};

export default WatermarkBanner;
